import { RegisterScorePage } from './RegisterScorePage';
export default RegisterScorePage;
